import AsyncTable from './Table';

export default AsyncTable;

export type { Column, RequestPage } from './types';
